import { Component } from '@angular/core';

@Component({
  selector: 'app-invoice-icon',
  imports: [],
  templateUrl: './invoice-icon.html',
  styleUrl: './invoice-icon.scss',
})
export class InvoiceIcon {

}
